interface AddressParts {
  postalCode: string
  city: string
  street: string
}

/** Same shape the accountant UI uses: "{postalCode} {city}, {street}". */
export function formatFullAddress({ postalCode, city, street }: AddressParts): string {
  return `${postalCode} ${city}, ${street}`
}
